import { bl_fi_sales_commission_report_hdr_RowClass, bl_fi_sales_commission_report_line_RowClass } from '../../../dbschema';
import { BaseContainerModel } from '../../base-container.model';

export class CommissionReportContainerModel extends BaseContainerModel {
  bl_fi_sales_commission_report_hdr: bl_fi_sales_commission_report_hdr_RowClass = new bl_fi_sales_commission_report_hdr_RowClass();
  bl_fi_sales_commission_report_line: bl_fi_sales_commission_report_line_RowClass[] = [];
}

export class CommissionReportHdrContainerModel extends BaseContainerModel {
  bl_fi_sales_commission_report_hdr: bl_fi_sales_commission_report_hdr_RowClass = new bl_fi_sales_commission_report_hdr_RowClass();
}